import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  doc_no: string;
  vendor_code: string;
  vendor_name: string;
  receiving_doc_no: string;
  return_date: string | null;
  amount: number;
  status: string;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ApproveResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ApprovalFilter {
  docStart: string;
  docEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const d506Api = {
  // GET /api/d506/pending?docStart=&docEnd=
  async getPending(filter: ApprovalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/d506/pending', {
      params: {
        docStart: filter.docStart,
        docEnd: filter.docEnd,
      },
    });
    return res.data;
  },

  // POST /api/d506/approve
  async approve(docNos: string[]): Promise<ApproveResponse> {
    // The call is reached only from D506Approval's Popconfirm onConfirm.
    // Keep that UI confirmation bound to the backend A2 confirmation gate.
    const res = await apiClient.post('/api/d506/approve', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
